import { Modal } from 'cpool-components/general/Modal';
import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';

import { FormLoansTable } from './FormLoansTable';

type FormLoansModalProps = {
    onClose: () => void;
    lead: SchemaLoanRequestResolver_Get;
};

const FormLoansModal: React.FC<FormLoansModalProps> = ({ lead, onClose }) => {
    const { t } = useTranslation();

    return (
        <Modal open onClose={onClose} title={t('EXISTING_LOANS.MODAL_HEADING_APPLICANT')} panelClassName="max-w-6xl">
            <FormLoansTable
                currentLoans={lead.haushalt.verbindlichkeiten}
                owner="ANTRAGSTELLER_1"
                applicant={lead.antragsteller1}
            />
            <FormLoansTable
                currentLoans={lead.haushalt.verbindlichkeiten}
                owner="ANTRAGSTELLER_2"
                applicant={lead.antragsteller2 || undefined}
            />
            <FormLoansTable currentLoans={lead.haushalt.verbindlichkeiten} owner="BEIDE" />
        </Modal>
    );
};

export default FormLoansModal;
